import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=0b70560d&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b70560d')) {
      api.createRecord('0b70560d', component.options)
    } else {
      api.reload('0b70560d', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=0b70560d&", function () {
      api.rerender('0b70560d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/campaign/Index.vue"
export default component.exports